// Tiny client-side router. Sessions live at /workspace/<id>; the root (/) is the
// landing. Cloudflare Pages serves index.html for every path (public/_redirects),
// so deep links resolve to the SPA, which reads the path here.

const WS = /^\/workspace\/([A-Za-z0-9-]+)\/?$/;

export function currentWorkspaceId(): string | null {
  const m = location.pathname.match(WS);
  return m ? (m[1] ?? null) : null;
}

export function goToWorkspace(id: string): void {
  const path = `/workspace/${id}`;
  if (location.pathname !== path) history.pushState({ id }, "", path);
}

// --- Backendless share: the song is encoded into the URL hash (#s=...) ------
// No server needed — a link round-trips event layers + settings. (Audio/voice
// layers are too large for a URL, so they're omitted from a shared link.)

export function encodeShareHash(payload: unknown): string {
  const json = JSON.stringify(payload);
  const b64 = btoa(unescape(encodeURIComponent(json)));
  return `${location.origin}/#s=${b64}`;
}

export function readShareHash(): unknown | null {
  const m = location.hash.match(/[#&]s=([^&]+)/);
  if (!m || !m[1]) return null;
  try {
    return JSON.parse(decodeURIComponent(escape(atob(m[1]))));
  } catch {
    return null;
  }
}

export function clearShareHash(): void {
  if (location.hash) history.replaceState(null, "", location.pathname);
}
